/**
 * @property {number}  red
 * @property {number}  green
 * @property {number}  blue
 */

/**
 * @property {number}  red
 * @property {number}  green
 * @property {number}  blue
 * @property {number}  alpha
 */
const hexRegex = /^#[a-fA-F0-9]{6}$/;
const hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

function toHex(value) {
  const hex = value.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}

function rgb(value, green, blue) {
  if (typeof value === "number" && typeof green === "number" && typeof blue === "number") {
    return `#${toHex(value)}${toHex(green)}${toHex(blue)}`;
  }

  throw new Error(`Unable to parse RGB from ${value}`);
}

function rgba(firstValue) {
  return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : `rgba(${firstValue.red},${firstValue.green},${firstValue.blue},${firstValue.alpha})`;
}

function parseToRgb(color) {
  if (color.match(hexRegex)) {
    return {
      red: parseInt(`${color[1]}${color[2]}`, 16),
      green: parseInt(`${color[3]}${color[4]}`, 16),
      blue: parseInt(`${color[5]}${color[6]}`, 16)
    };
  }

  if (color.match(hexRgbaRegex)) {
    const alpha = parseFloat((parseInt(`${color[7]}${color[8]}`, 16) / 255).toFixed(2));
    return {
      red: parseInt(`${color[1]}${color[2]}`, 16),
      green: parseInt(`${color[3]}${color[4]}`, 16),
      blue: parseInt(`${color[5]}${color[6]}`, 16),
      alpha
    };
  }

  throw new Error(`Unable to parse RGB from ${color}`);
}

function transparentize(amount, color) {
  if (color === "transparent") return color;
  const parsedColor = parseToRgb(color);
  const alpha = "alpha" in parsedColor ? parsedColor.alpha : 1;
  const colorWithAlpha = { ...parsedColor,
    alpha: guard(0, 1, Number((alpha * 100 - parseFloat(amount.toString()) * 100).toFixed(2)) / 100)
  };
  return rgba(colorWithAlpha);
}

export { transparentize as default };
